var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('span',{staticClass:"status_text",class:_vm.colorstatus},[_vm._v("\n        "+_vm._s(_vm.textstatus)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }